import { createContext, type ReactNode, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SendMoneySelector from '../components/send-money-selector';

type SendMoneyModalContextType = {
  openModal: (walletId: string) => void;
  closeModal: () => void;
};

const SendMoneyModalContext = createContext<SendMoneyModalContextType | undefined>(undefined);

export const useSendMoneyModal = () => {
  const context = useContext(SendMoneyModalContext);
  if (!context) {
    throw new Error('useSendMoneyModal must be used within a SendMoneyModalProvider');
  }
  return context;
};

export default function SendMoneyModalProvider({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const [walletId, setWalletId] = useState<string>();

  const closeModal = () => setWalletId(undefined);
  const openModal = (nextWalletId: string) => setWalletId(nextWalletId);
  const openExternalTransfer = () => {
    if (!walletId) return;
    const selectedWalletId = walletId;
    closeModal();
    navigate(`/wallets/${selectedWalletId}/payout`);
  };

  return (
    <SendMoneyModalContext.Provider value={{ openModal, closeModal }}>
      {children}
      <SendMoneySelector
        open={Boolean(walletId)}
        onOpenChange={(open) => { if (!open) closeModal(); }}
        onExternalTransfer={openExternalTransfer}
      />
    </SendMoneyModalContext.Provider>
  );
}
